<template>
    <div id="scene1" class="splash Spash.vue">
      <div class="splash__grid" v-bind:class="{'hidden':isAnimationDisabled}"></div>
      <!-- /.splash__grid -->
      <div class="splash__challenge">

        <div class="switch" v-bind:class="{'warn': showWarningRipple && isAnimationDisabled}">
          <div class="warn__text">Desafie sua mente antes de entrar no site</div>
          <!-- /.warn__text -->
        </div>
        <!-- /.switch -->

        <h1>
          <span>Dare</span>
          <span>Your</span>
          <span>Mind</span>
        </h1>

        <a href="javascript:;" class="splash__link-next" @click="goToSite()">
          <span>Entre no site</span> <i class="arrow"></i>
        </a>
        <!-- /.next -->

      </div>
      <!-- /.dare -->
      <logo class="splash__logo"></logo>
      <!-- /.splash__logo -->

    </div>

</template>

<script>
  import GyroNorm from 'gyronorm';
  import logo from '../assets/logo.svg';
  import store from '../store';

  import exec from 'script-loader!@hughsk/fulltilt/dist/fulltilt';

  export default {
    name: 'Splash',
    data() {
      return {
        isAnimationDisabled: false,
        showWarningRipple: true
      }
    },
    components:{
      logo
    },
    beforeDestroy(){
      try{
        this.gn.end();
        $('#scene1').off('mousemove');
      }catch (e){}
    },
    mounted() {
      this.log('mounted: ' + this.$options.name);

      // ativa animação

      this.enableDareAnimation()

      // seta a classe do menu principal
      this.$store.commit('setMenuClass', 'hidden');

      this.gn = new GyroNorm();
      let gn = this.gn;

      let lastExecution;
      gn.init().then(function(){
        gn.start(function(data){

          let now = Date.now();
          if (now - lastExecution < 50) return; // ~60Hz
          lastExecution = now;

          if (data.dm.gx !== 0  ){
            let val = data.dm.gx;
            $('.splash__grid').css('background-position-x', (val) + 'px');
          }
        });
      }).catch(function(e){
        // Catch if the DeviceOrientation or DeviceMotion is not supported by the browser or device
        console.log('DeviceMotion no supported');
      });
    },
    methods: {
      enableDareAnimation() {
        $('#scene1').on('mousemove', function (toto) {
          let val = toto.offsetX / 14;
          $('.splash__grid').css('background-position-x', (val) + 'px');
        });
      },
      /**
       * Toggler para animação do background
       */
      goToSite(){
        // if (this.isAnimationDisabled){
        //   this.showWarningRipple = true;
        // }else{
          this.$router.push('/home');
        // }
      }
    }
  }
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/Splash.vue